import{Container as i}from"inversify";import{Cookies as n}from"../cookies/index.js";import{INVERSIFY_TYPES as r}from"./types.js";const o=new i;o.bind(r.cookies).to(n).inSingletonScope();export{o as inversifyContainer};
